import HeroMain from './hero-main';
export default HeroMain;